import React from "react";
import { useNavigate } from "react-router-dom";
import svg10 from "../../../../assets/svg/svg10.svg";

function EventOrganizersHero({ hero }) {
  const navigate = useNavigate();

  return (
    <div className="bg-hero-organizers h-auto pt-[5rem]">
      <div className="lg:px-[5.69rem] px-3 lg:min-h-[45rem] min-h-auto">
        <div className="lg:mt-[5.12rem] mt-[1rem] flex lg:flex-row flex-col justify-between gap-[2rem] lg:gap-[3rem] font-lexend">
          {/* Left */}
          <div className="w-full lg:max-w-[55%]">
            <div className="text-[#2F2B43] text-[1.75rem] md:text-[2.5rem] lg:text-[3rem] font-[600] leading-tight lg:leading-[3.375rem] tracking-[-0.06rem] max-w-full lg:max-w-[45rem] w-full">
              {hero?.titleBold}{" "}
              <span className="font-[400]">{hero?.titleLight}</span>
            </div>

            <div className="mt-[1.25rem] text-[#7A7493] text-[1rem] md:text-[1.125rem] font-[400] leading-[1.625rem] tracking-[-0.0135rem] max-w-full lg:max-w-[36.625rem] w-full">
              {hero?.desc}
            </div>

            <div className="lg:mt-[4rem] mt-[1.5rem]">
              <button
                className="cstm-btn-2 !w-auto !min-w-0 group transition-all duration-500 ease-in-out"
                onClick={() => navigate("/request-demo")}
              >
                Request a demo
                <img
                  src={svg10}
                  alt="arrow"
                  className="w-4 h-3 overflow-hidden opacity-0 group-hover:w-[1.25rem] group-hover:opacity-100 group-hover:ml-[.375rem] transition-all duration-500 ease-in-out"
                />
              </button>
            </div>
          </div>

          {/* Right — dashboard image */}
          <div className="w-full lg:max-w-[50%] flex items-center justify-center">
            <img
              src={hero?.img}
              alt={hero?.titleBold}
              className="max-w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventOrganizersHero;
